/* tslint:disable */
import {
  App
} from '../index';

declare var Object: any;
export interface InstallationInterface {
  createdby?: string;
  custom_data?: any;
  lastupdatedby?: string;
  linked_ids?: Array<string>;
  softwareappid?: string;
  token: string;
  type?: string;
  id?: any;
  appId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App;
}

export class Installation implements InstallationInterface {
  createdby: string;
  custom_data: any;
  lastupdatedby: string;
  linked_ids: Array<string>;
  softwareappid: string;
  token: string;
  type: string;
  id: any;
  appId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App;
  constructor(data?: InstallationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Installation`.
   */
  public static getModelName() {
    return "Installation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Installation for dynamic purposes.
  **/
  public static factory(data: InstallationInterface): Installation{
    return new Installation(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Installation',
      plural: 'installations',
      properties: {
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        custom_data: {
          name: 'custom_data',
          type: 'any'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        linked_ids: {
          name: 'linked_ids',
          type: 'Array&lt;string&gt;'
        },
        softwareappid: {
          name: 'softwareappid',
          type: 'string'
        },
        token: {
          name: 'token',
          type: 'string'
        },
        type: {
          name: 'type',
          type: 'string'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Installation.ts